import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { YMMDProductsResultsModel } from "@store/Store/Components/RsswYMMD/Handlers/getProductsYMMD";
import RsswYMMDState from "@store/Store/Components/RsswYMMD/RsswYMMDState";
import { YMMDResultsModel } from "@store/Types/ApiModels";
import { fields } from "@store/Widgets/Header/RsswYMMD";
import { Draft } from "immer";

export interface YmmdAllResultsModel {
    result: YmmdAllResultsArraysModel;
}

export interface YmmdAllResultsArraysModel {
    years: string[];
    makes: string[];
    models: string[];
    diameters: string[];
}

const initialState: RsswYMMDState = {
    year: {
        value: "",
        result: [],
    },
    make: {
        value: "",
        result: [],
    },
    model: {
        value: "",
        result: [],
    },
    diameter: {
        value: "",
        result: [],
    },
    products: {
        availableDimensions: [],
        productsIds: [],
    },
    fitments: [],
    isLoading: false,
};

const reducer = {
    "Components/RsswYMMD/SetParams": (
        draft: Draft<RsswYMMDState>,
        action: { apiResult: YMMDResultsModel; key: string },
    ) => {
        const { key, apiResult } = action;

        (draft as any)[key].result = apiResult.result;
        (draft as any)[key].value = key ?? "";
    },
    "Components/RsswYMMD/SetAllParams": (draft: Draft<RsswYMMDState>, action: { apiResult: YmmdAllResultsModel }) => {
        const { apiResult } = action;

        draft.year.result = apiResult.result.years;
        draft.year.value = "year" ?? "";
        draft.make.result = apiResult.result.makes;
        draft.make.value = "make" ?? "";
        draft.model.result = apiResult.result.models;
        draft.model.value = "model" ?? "";
        draft.diameter.result = apiResult.result.diameters;
        draft.diameter.value = "diameter" ?? "";
    },
    "Components/RsswYMMD/SetProducts": (
        draft: Draft<RsswYMMDState>,
        action: { apiResult: YMMDProductsResultsModel },
    ) => {
        const { apiResult } = action;

        draft.fitments = [];
        draft.products.availableDimensions = apiResult.result.availableDimensions;
        draft.products.productsIds = apiResult.result.products;

        if (apiResult.result.fitments?.length > 0) {
            draft.fitments = apiResult.result.fitments;
        }
    },
    "Components/RsswYMMD/ClearDropdown": (draft: Draft<RsswYMMDState>, action: { key: string }) => {
        const { key } = action;

        switch (key) {
            case fields.year:
                draft.make.result = [];
                draft.make.value = "";
                draft.model.result = [];
                draft.model.value = "";
                draft.diameter.result = [];
                draft.diameter.value = "";
                break;
            case fields.make:
                draft.model.result = [];
                draft.model.value = "";
                draft.diameter.result = [];
                draft.diameter.value = "";
                break;
            default:
                draft.diameter.result = [];
                draft.diameter.value = "";
                break;
        }
    },
    "Components/RsswYMMD/Clear": (draft: Draft<RsswYMMDState>) => {
        draft.make.result = [];
        draft.model.result = [];
        draft.diameter.result = [];
    },
    "Components/RsswYMMD/BeginLoadProductsYMMD": (draft: Draft<RsswYMMDState>) => {
        draft.isLoading = true;
    },
    "Components/RsswYMMD/CompleteLoadProductsYMMD": (draft: Draft<RsswYMMDState>) => {
        draft.isLoading = false;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
